import { Typography } from 'modules/Typography';
import { Falcon } from 'modules/macro';
import { SortIcon } from './SortIcon';
import { useLoad } from '../Table/hooks/useLoad';
import { useSort } from '../Table/hooks/useSort';
import { HeaderTextContainer, IconContainer, SortButton, StyledTypography } from './styled';
export function TableHeaderText(props) {
    const { children, sortId } = props;
    const { order, onSort } = useSort(sortId);
    const { loading } = useLoad();
    const active = Boolean(order);
    if (!sortId) {
        return (<HeaderTextContainer>
        <Typography $fontSize="small" $appearance="100">
          {children}
        </Typography>
      </HeaderTextContainer>);
    }
    const getIcon = () => {
        if (active) {
            return <SortIcon order={order}/>;
        }
        return <Falcon icon="caret-down" sourceConfig={{ family: 'classic', style: 'solid' }}/>;
    };
    return (<SortButton $active={active} type="button" disabled={loading} onClick={onSort}>
      <HeaderTextContainer>
        <StyledTypography $fontSize="small">{children}</StyledTypography>
        <IconContainer $loading={loading}>{getIcon()}</IconContainer>
      </HeaderTextContainer>
    </SortButton>);
}
